import React, { useState, useEffect } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { getUddyamaanAssessmentHistory } from "../../../services/adminApiService/uddyamaanApi/uddyamaanApi";

const STAGE_ORDER = ["nyaya_panchayat", "block", "district"];
const STAGE_TITLES = {
  nyaya_panchayat: "Nyaya Panchayat Level",
  block: "Block Level",
  district: "District Level",
};

const FIELD_ROWS = (r) => [
  { label: "6x10 Shuttle Run", value: r.shuttle_run_seconds, unit: "sec", points: r.shuttle_run_points },
  { label: "30m Flying Run", value: r.flying_run_seconds, unit: "sec", points: r.flying_run_points },
  { label: "600m Run", value: (r.run_600m_minutes || r.run_600m_seconds) ? `${r.run_600m_minutes ?? 0} min ${r.run_600m_seconds ?? 0} sec` : null, points: r.run_600m_points },
  { label: "Standing Broad Jump", value: r.broad_jump_cm, unit: "cm", points: r.broad_jump_points },
  { label: "Medicine Ball Throw (1 kg)", value: (r.medicine_ball_meters || r.medicine_ball_cm) ? `${r.medicine_ball_meters ?? 0} m ${r.medicine_ball_cm ?? 0} cm` : null, points: r.medicine_ball_points },
  { label: "Forward Bend Reach", value: r.forward_bend_cm, unit: "cm", points: r.forward_bend_points },
];

const AssessmentHistoryModal = ({ show, onHide, application }) => {
  const [results, setResults] = useState([]);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (!show || !application?.id) return;
    setFetching(true);
    getUddyamaanAssessmentHistory(application.id)
      .then(res => setResults(res?.data?.data?.results || []))
      .catch(() => setResults([]))
      .finally(() => setFetching(false));
  }, [show, application?.id]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>
          View All Assessments — {application?.name || ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fetching ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status" />
          </div>
        ) : (
          STAGE_ORDER.map((stage, idx) => {
            const result = results.find(r => r.stage === stage);
            return (
              <div
                key={stage}
                className={idx < STAGE_ORDER.length - 1 ? "mb-4 pb-3" : "mb-2"}
                style={idx < STAGE_ORDER.length - 1 ? { borderBottom: "1px solid #eee" } : undefined}
              >
                <h6 style={{ fontWeight: 600, color: "#4338CA" }}>{STAGE_TITLES[stage]}</h6>
                {result ? (
                  <>
                    <Row className="g-3">
                      {FIELD_ROWS(result).map(f => (
                        <Col md={6} key={f.label}>
                          <div style={{ fontSize: 13, color: "#6B7280" }}>{f.label}</div>
                          <div style={{ fontWeight: 500 }}>
                            {f.value !== null && f.value !== undefined && f.value !== "" ? `${f.value}${f.unit ? ` ${f.unit}` : ""}` : "—"}
                            {f.points !== null && f.points !== undefined && f.points !== "" && (
                              <span className="text-muted" style={{ fontWeight: 400, fontSize: 13 }}> · {f.points} pts</span>
                            )}
                          </div>
                        </Col>
                      ))}
                      <Col xs={12}>
                        <div style={{ fontSize: 13, color: "#6B7280" }}>Notes</div>
                        <div style={{ fontWeight: 500 }}>{result.notes || "—"}</div>
                      </Col>
                      <Col xs={12}>
                        <div
                          className="d-flex justify-content-between align-items-center p-2 px-3"
                          style={{ background: "#EEF2FF", borderRadius: 8, border: "1px solid #C7D2FE" }}
                        >
                          <span style={{ fontWeight: 600, color: "#4338CA", fontSize: 14 }}>Total Points</span>
                          <span style={{ fontWeight: 700, fontSize: 16, color: "#4338CA" }}>
                            {result.total_points ?? 0} / 60
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                      {result.assessor_name ? `Assessed by: ${result.assessor_name}` : ""}
                      {result.created_at ? ` (${new Date(result.created_at).toLocaleDateString("en-IN")})` : ""}
                    </div>
                  </>
                ) : (
                  <div className="text-muted" style={{ fontSize: 14 }}>Not yet assessed at this level.</div>
                )}
              </div>
            );
          })
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" className="w-100" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssessmentHistoryModal;
